module.exports = __webpack_public_path__ + "img/main-4.024d37ed.svg";